/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateOrUpdateCompanyRequest,
  ExportDsfinvKReport400Response,
  GenerateInvoice200Response,
  GenerateInvoiceRequest,
  GetCompanies200ResponseInner,
  GetProductsFiltersParameterInnerInner,
  GetProductsPaginationParameter,
  GetProductsSortingParameterInner,
  GetReportTab200Response,
  GetReportTabs200Response,
  GetTBAIAvailableQuarters200ResponseInner,
  GetZReportDates200ResponseInner,
  RefundTabRequest,
  SendInvoiceEmailRequest,
} from '../models/index';
import {
    CreateOrUpdateCompanyRequestFromJSON,
    CreateOrUpdateCompanyRequestToJSON,
    ExportDsfinvKReport400ResponseFromJSON,
    ExportDsfinvKReport400ResponseToJSON,
    GenerateInvoice200ResponseFromJSON,
    GenerateInvoice200ResponseToJSON,
    GenerateInvoiceRequestFromJSON,
    GenerateInvoiceRequestToJSON,
    GetCompanies200ResponseInnerFromJSON,
    GetCompanies200ResponseInnerToJSON,
    GetProductsFiltersParameterInnerInnerFromJSON,
    GetProductsFiltersParameterInnerInnerToJSON,
    GetProductsPaginationParameterFromJSON,
    GetProductsPaginationParameterToJSON,
    GetProductsSortingParameterInnerFromJSON,
    GetProductsSortingParameterInnerToJSON,
    GetReportTab200ResponseFromJSON,
    GetReportTab200ResponseToJSON,
    GetReportTabs200ResponseFromJSON,
    GetReportTabs200ResponseToJSON,
    GetTBAIAvailableQuarters200ResponseInnerFromJSON,
    GetTBAIAvailableQuarters200ResponseInnerToJSON,
    GetZReportDates200ResponseInnerFromJSON,
    GetZReportDates200ResponseInnerToJSON,
    RefundTabRequestFromJSON,
    RefundTabRequestToJSON,
    SendInvoiceEmailRequestFromJSON,
    SendInvoiceEmailRequestToJSON,
} from '../models/index';

export interface CreateOrUpdateCompanyOperationRequest {
    createOrUpdateCompanyRequest: CreateOrUpdateCompanyRequest;
}

export interface DeleteBillRequest {
    billId: string;
}

export interface ExportAttendancePDFRequest {
    startDate: Date;
    endDate: Date;
    locationIds?: Array<string>;
    employeeIds?: Array<string>;
}

export interface ExportCashbookReportPDFRequest {
    startDate: Date;
    endDate: Date;
}

export interface ExportDatevReportRequest {
    startDate: Date;
    endDate: Date;
    locationIds: Array<string>;
    format: ExportDatevReportFormatEnum;
}

export interface ExportDsfinvKReportRequest {
    startDate: Date;
    endDate: Date;
    format: ExportDsfinvKReportFormatEnum;
}

export interface ExportPayoutReportPdfRequest {
    startDate: Date;
    endDate: Date;
}

export interface ExportSalesJournalReportPdfRequest {
    startDate: Date;
    endDate: Date;
}

export interface ExportTBAIBillsCSVRequest {
    locationIds: Array<string>;
    startDate: Date;
    endDate: Date;
}

export interface ExportTabsRequest {
    startDate: Date;
    endDate: Date;
    format: ExportTabsFormatEnum;
    locationIds?: Array<string>;
    brandIds?: Array<string>;
    pickupTypes?: Array<string>;
    sources?: Array<string>;
}

export interface ExportZReportRequest {
    id: string;
}

export interface GenerateInvoiceOperationRequest {
    billId: string;
    generateInvoiceRequest: GenerateInvoiceRequest;
}

export interface GetCompaniesRequest {
    pagination?: GetProductsPaginationParameter;
    filters?: Array<Array<GetProductsFiltersParameterInnerInner>>;
    sorting?: Array<GetProductsSortingParameterInner>;
    startDate?: Date;
    endDate?: Date;
}

export interface GetQuarterTBAIBillsRequest {
    quarter: number;
    year: number;
}

export interface GetReportTabRequest {
    tabId: string;
}

export interface GetReportTabsRequest {
    pagination?: GetProductsPaginationParameter;
    filters?: Array<Array<GetProductsFiltersParameterInnerInner>>;
    sorting?: Array<GetProductsSortingParameterInner>;
    startDate?: Date;
    endDate?: Date;
}

export interface OpenTabRequest {
    tabId: string;
}

export interface RefundTabOperationRequest {
    tabId: string;
    refundTabRequest: RefundTabRequest;
}

export interface SendInvoiceEmailOperationRequest {
    billId: string;
    sendInvoiceEmailRequest: SendInvoiceEmailRequest;
}

/**
 * 
 */
export class ReportsApi extends runtime.BaseAPI {

    /**
     */
    async createOrUpdateCompanyRaw(requestParameters: CreateOrUpdateCompanyOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['createOrUpdateCompanyRequest'] == null) {
            throw new runtime.RequiredError(
                'createOrUpdateCompanyRequest',
                'Required parameter "createOrUpdateCompanyRequest" was null or undefined when calling createOrUpdateCompany().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/reports/tabs/companies`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOrUpdateCompanyRequestToJSON(requestParameters['createOrUpdateCompanyRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async createOrUpdateCompany(requestParameters: CreateOrUpdateCompanyOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createOrUpdateCompanyRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteBillRaw(requestParameters: DeleteBillRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['billId'] == null) {
            throw new runtime.RequiredError(
                'billId',
                'Required parameter "billId" was null or undefined when calling deleteBill().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reports/tabs/{billId}`.replace(`{${"billId"}}`, encodeURIComponent(String(requestParameters['billId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteBill(requestParameters: DeleteBillRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteBillRaw(requestParameters, initOverrides);
    }

    /**
     */
    async exportAttendancePDFRaw(requestParameters: ExportAttendancePDFRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters['startDate'] == null) {
            throw new runtime.RequiredError(
                'startDate',
                'Required parameter "startDate" was null or undefined when calling exportAttendancePDF().'
            );
        }

        if (requestParameters['endDate'] == null) {
            throw new runtime.RequiredError(
                'endDate',
                'Required parameter "endDate" was null or undefined when calling exportAttendancePDF().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['locationIds'] != null) {
            queryParameters['locationIds'] = requestParameters['locationIds'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = (requestParameters['startDate'] as any).toISOString();
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = (requestParameters['endDate'] as any).toISOString();
        }

        if (requestParameters['employeeIds'] != null) {
            queryParameters['employeeIds'] = requestParameters['employeeIds'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reports/attendance/pdf`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async exportAttendancePDF(requestParameters: ExportAttendancePDFRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.exportAttendancePDFRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async exportCashbookReportPDFRaw(requestParameters: ExportCashbookReportPDFRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters['startDate'] == null) {
            throw new runtime.RequiredError(
                'startDate',
                'Required parameter "startDate" was null or undefined when calling exportCashbookReportPDF().'
            );
        }

        if (requestParameters['endDate'] == null) {
            throw new runtime.RequiredError(
                'endDate',
                'Required parameter "endDate" was null or undefined when calling exportCashbookReportPDF().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = (requestParameters['startDate'] as any).toISOString();
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = (requestParameters['endDate'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reports/cashbook/pdf`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async exportCashbookReportPDF(requestParameters: ExportCashbookReportPDFRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.exportCashbookReportPDFRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async exportDatevReportRaw(requestParameters: ExportDatevReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters['startDate'] == null) {
            throw new runtime.RequiredError(
                'startDate',
                'Required parameter "startDate" was null or undefined when calling exportDatevReport().'
            );
        }

        if (requestParameters['endDate'] == null) {
            throw new runtime.RequiredError(
                'endDate',
                'Required parameter "endDate" was null or undefined when calling exportDatevReport().'
            );
        }

        if (requestParameters['locationIds'] == null) {
            throw new runtime.RequiredError(
                'locationIds',
                'Required parameter "locationIds" was null or undefined when calling exportDatevReport().'
            );
        }

        if (requestParameters['format'] == null) {
            throw new runtime.RequiredError(
                'format',
                'Required parameter "format" was null or undefined when calling exportDatevReport().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = (requestParameters['startDate'] as any).toISOString();
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = (requestParameters['endDate'] as any).toISOString();
        }

        if (requestParameters['locationIds'] != null) {
            queryParameters['locationIds'] = requestParameters['locationIds'];
        }

        if (requestParameters['format'] != null) {
            queryParameters['format'] = requestParameters['format'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reports/datev/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async exportDatevReport(requestParameters: ExportDatevReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.exportDatevReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async exportDsfinvKReportRaw(requestParameters: ExportDsfinvKReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['startDate'] == null) {
            throw new runtime.RequiredError(
                'startDate',
                'Required parameter "startDate" was null or undefined when calling exportDsfinvKReport().'
            );
        }

        if (requestParameters['endDate'] == null) {
            throw new runtime.RequiredError(
                'endDate',
                'Required parameter "endDate" was null or undefined when calling exportDsfinvKReport().'
            );
        }

        if (requestParameters['format'] == null) {
            throw new runtime.RequiredError(
                'format',
                'Required parameter "format" was null or undefined when calling exportDsfinvKReport().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = (requestParameters['startDate'] as any).toISOString();
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = (requestParameters['endDate'] as any).toISOString();
        }

        if (requestParameters['format'] != null) {
            queryParameters['format'] = requestParameters['format'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reports/dsfinv-k/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async exportDsfinvKReport(requestParameters: ExportDsfinvKReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.exportDsfinvKReportRaw(requestParameters, initOverrides);
    }

    /**
     */
    async exportPayoutReportPdfRaw(requestParameters: ExportPayoutReportPdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters['startDate'] == null) {
            throw new runtime.RequiredError(
                'startDate',
                'Required parameter "startDate" was null or undefined when calling exportPayoutReportPdf().'
            );
        }

        if (requestParameters['endDate'] == null) {
            throw new runtime.RequiredError(
                'endDate',
                'Required parameter "endDate" was null or undefined when calling exportPayoutReportPdf().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = (requestParameters['startDate'] as any).toISOString();
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = (requestParameters['endDate'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reports/payouts/pdf`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async exportPayoutReportPdf(requestParameters: ExportPayoutReportPdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.exportPayoutReportPdfRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async exportSalesJournalReportPdfRaw(requestParameters: ExportSalesJournalReportPdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters['startDate'] == null) {
            throw new runtime.RequiredError(
                'startDate',
                'Required parameter "startDate" was null or undefined when calling exportSalesJournalReportPdf().'
            );
        }

        if (requestParameters['endDate'] == null) {
            throw new runtime.RequiredError(
                'endDate',
                'Required parameter "endDate" was null or undefined when calling exportSalesJournalReportPdf().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = (requestParameters['startDate'] as any).toISOString();
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = (requestParameters['endDate'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reports/sales-journal/pdf`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async exportSalesJournalReportPdf(requestParameters: ExportSalesJournalReportPdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.exportSalesJournalReportPdfRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async exportTBAIBillsCSVRaw(requestParameters: ExportTBAIBillsCSVRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['locationIds'] == null) {
            throw new runtime.RequiredError(
                'locationIds',
                'Required parameter "locationIds" was null or undefined when calling exportTBAIBillsCSV().'
            );
        }

        if (requestParameters['startDate'] == null) {
            throw new runtime.RequiredError(
                'startDate',
                'Required parameter "startDate" was null or undefined when calling exportTBAIBillsCSV().'
            );
        }

        if (requestParameters['endDate'] == null) {
            throw new runtime.RequiredError(
                'endDate',
                'Required parameter "endDate" was null or undefined when calling exportTBAIBillsCSV().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['locationIds'] != null) {
            queryParameters['locationIds'] = requestParameters['locationIds'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = (requestParameters['startDate'] as any).toISOString();
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = (requestParameters['endDate'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reports/tbai/csv`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async exportTBAIBillsCSV(requestParameters: ExportTBAIBillsCSVRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.exportTBAIBillsCSVRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async exportTabsRaw(requestParameters: ExportTabsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['startDate'] == null) {
            throw new runtime.RequiredError(
                'startDate',
                'Required parameter "startDate" was null or undefined when calling exportTabs().'
            );
        }

        if (requestParameters['endDate'] == null) {
            throw new runtime.RequiredError(
                'endDate',
                'Required parameter "endDate" was null or undefined when calling exportTabs().'
            );
        }

        if (requestParameters['format'] == null) {
            throw new runtime.RequiredError(
                'format',
                'Required parameter "format" was null or undefined when calling exportTabs().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['locationIds'] != null) {
            queryParameters['locationIds'] = requestParameters['locationIds'];
        }

        if (requestParameters['brandIds'] != null) {
            queryParameters['brandIds'] = requestParameters['brandIds'];
        }

        if (requestParameters['pickupTypes'] != null) {
            queryParameters['pickupTypes'] = requestParameters['pickupTypes'];
        }

        if (requestParameters['sources'] != null) {
            queryParameters['sources'] = requestParameters['sources'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = (requestParameters['startDate'] as any).toISOString();
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = (requestParameters['endDate'] as any).toISOString();
        }

        if (requestParameters['format'] != null) {
            queryParameters['format'] = requestParameters['format'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reports/tabs/csv`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async exportTabs(requestParameters: ExportTabsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.exportTabsRaw(requestParameters, initOverrides);
    }

    /**
     */
    async exportZReportRaw(requestParameters: ExportZReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling exportZReport().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reports/z/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async exportZReport(requestParameters: ExportZReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.exportZReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async generateInvoiceRaw(requestParameters: GenerateInvoiceOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GenerateInvoice200Response>> {
        if (requestParameters['billId'] == null) {
            throw new runtime.RequiredError(
                'billId',
                'Required parameter "billId" was null or undefined when calling generateInvoice().'
            );
        }

        if (requestParameters['generateInvoiceRequest'] == null) {
            throw new runtime.RequiredError(
                'generateInvoiceRequest',
                'Required parameter "generateInvoiceRequest" was null or undefined when calling generateInvoice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/reports/tabs/{billId}/invoice`.replace(`{${"billId"}}`, encodeURIComponent(String(requestParameters['billId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GenerateInvoiceRequestToJSON(requestParameters['generateInvoiceRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GenerateInvoice200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async generateInvoice(requestParameters: GenerateInvoiceOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GenerateInvoice200Response> {
        const response = await this.generateInvoiceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getCompaniesRaw(requestParameters: GetCompaniesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetCompanies200ResponseInner>>> {
        const queryParameters: any = {};

        if (requestParameters['pagination'] != null) {
            queryParameters['pagination'] = requestParameters['pagination'];
        }

        if (requestParameters['filters'] != null) {
            queryParameters['filters'] = requestParameters['filters'];
        }

        if (requestParameters['sorting'] != null) {
            queryParameters['sorting'] = requestParameters['sorting'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = (requestParameters['startDate'] as any).toISOString();
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = (requestParameters['endDate'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reports/tabs/companies`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetCompanies200ResponseInnerFromJSON));
    }

    /**
     */
    async getCompanies(requestParameters: GetCompaniesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetCompanies200ResponseInner>> {
        const response = await this.getCompaniesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getPaymentMethodsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reports/tabs/payment-methods`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async getPaymentMethods(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.getPaymentMethodsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getQuarterTBAIBillsRaw(requestParameters: GetQuarterTBAIBillsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['quarter'] == null) {
            throw new runtime.RequiredError(
                'quarter',
                'Required parameter "quarter" was null or undefined when calling getQuarterTBAIBills().'
            );
        }

        if (requestParameters['year'] == null) {
            throw new runtime.RequiredError(
                'year',
                'Required parameter "year" was null or undefined when calling getQuarterTBAIBills().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['quarter'] != null) {
            queryParameters['quarter'] = requestParameters['quarter'];
        }

        if (requestParameters['year'] != null) {
            queryParameters['year'] = requestParameters['year'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reports/tbai/quarter-bills`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async getQuarterTBAIBills(requestParameters: GetQuarterTBAIBillsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getQuarterTBAIBillsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getReportTabRaw(requestParameters: GetReportTabRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetReportTab200Response>> {
        if (requestParameters['tabId'] == null) {
            throw new runtime.RequiredError(
                'tabId',
                'Required parameter "tabId" was null or undefined when calling getReportTab().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reports/tabs/{tabId}`.replace(`{${"tabId"}}`, encodeURIComponent(String(requestParameters['tabId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetReportTab200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getReportTab(requestParameters: GetReportTabRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetReportTab200Response> {
        const response = await this.getReportTabRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getReportTabsRaw(requestParameters: GetReportTabsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetReportTabs200Response>> {
        const queryParameters: any = {};

        if (requestParameters['pagination'] != null) {
            queryParameters['pagination'] = requestParameters['pagination'];
        }

        if (requestParameters['filters'] != null) {
            queryParameters['filters'] = requestParameters['filters'];
        }

        if (requestParameters['sorting'] != null) {
            queryParameters['sorting'] = requestParameters['sorting'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = (requestParameters['startDate'] as any).toISOString();
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = (requestParameters['endDate'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reports/tabs/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetReportTabs200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getReportTabs(requestParameters: GetReportTabsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetReportTabs200Response> {
        const response = await this.getReportTabsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getTBAIAvailableQuartersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetTBAIAvailableQuarters200ResponseInner>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reports/tbai/available-quarters`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetTBAIAvailableQuarters200ResponseInnerFromJSON));
    }

    /**
     */
    async getTBAIAvailableQuarters(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetTBAIAvailableQuarters200ResponseInner>> {
        const response = await this.getTBAIAvailableQuartersRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getZReportDatesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetZReportDates200ResponseInner>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reports/z/dates`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetZReportDates200ResponseInnerFromJSON));
    }

    /**
     */
    async getZReportDates(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetZReportDates200ResponseInner>> {
        const response = await this.getZReportDatesRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async openTabRaw(requestParameters: OpenTabRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['tabId'] == null) {
            throw new runtime.RequiredError(
                'tabId',
                'Required parameter "tabId" was null or undefined when calling openTab().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reports/tabs/{tabId}/open`.replace(`{${"tabId"}}`, encodeURIComponent(String(requestParameters['tabId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async openTab(requestParameters: OpenTabRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.openTabRaw(requestParameters, initOverrides);
    }

    /**
     */
    async refundTabRaw(requestParameters: RefundTabOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['tabId'] == null) {
            throw new runtime.RequiredError(
                'tabId',
                'Required parameter "tabId" was null or undefined when calling refundTab().'
            );
        }

        if (requestParameters['refundTabRequest'] == null) {
            throw new runtime.RequiredError(
                'refundTabRequest',
                'Required parameter "refundTabRequest" was null or undefined when calling refundTab().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/reports/tabs/{tabId}/refund`.replace(`{${"tabId"}}`, encodeURIComponent(String(requestParameters['tabId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RefundTabRequestToJSON(requestParameters['refundTabRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async refundTab(requestParameters: RefundTabOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.refundTabRaw(requestParameters, initOverrides);
    }

    /**
     */
    async sendInvoiceEmailRaw(requestParameters: SendInvoiceEmailOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['billId'] == null) {
            throw new runtime.RequiredError(
                'billId',
                'Required parameter "billId" was null or undefined when calling sendInvoiceEmail().'
            );
        }

        if (requestParameters['sendInvoiceEmailRequest'] == null) {
            throw new runtime.RequiredError(
                'sendInvoiceEmailRequest',
                'Required parameter "sendInvoiceEmailRequest" was null or undefined when calling sendInvoiceEmail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/reports/tabs/{billId}/email`.replace(`{${"billId"}}`, encodeURIComponent(String(requestParameters['billId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SendInvoiceEmailRequestToJSON(requestParameters['sendInvoiceEmailRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async sendInvoiceEmail(requestParameters: SendInvoiceEmailOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.sendInvoiceEmailRaw(requestParameters, initOverrides);
    }

}

/**
 * @export
 */
export const ExportDatevReportFormatEnum = {
    Csv: 'csv',
    Xlsx: 'xlsx'
} as const;
export type ExportDatevReportFormatEnum = typeof ExportDatevReportFormatEnum[keyof typeof ExportDatevReportFormatEnum];
/**
 * @export
 */
export const ExportDsfinvKReportFormatEnum = {
    Zip: 'zip',
    Tar: 'tar'
} as const;
export type ExportDsfinvKReportFormatEnum = typeof ExportDsfinvKReportFormatEnum[keyof typeof ExportDsfinvKReportFormatEnum];
/**
 * @export
 */
export const ExportTabsFormatEnum = {
    Csv: 'csv',
    Xlsx: 'xlsx'
} as const;
export type ExportTabsFormatEnum = typeof ExportTabsFormatEnum[keyof typeof ExportTabsFormatEnum];
